/** @flow */
import MultiGrid from './MultiGrid';

export default MultiGrid;
export {MultiGrid};
